(() => {
  function update(root = document) {
    root.querySelectorAll('.news-page').forEach((section) => {
      const links = [...section.querySelectorAll('.news-filter__button')];
      const selected = links.find((link) =>
        link.dataset.emptyNewsCategory &&
        window.location.hash === `#category-${link.dataset.emptyNewsCategory}`,
      );
      const empty = section.querySelector('[data-news-empty-category]');
      if (!empty) return;
      empty.hidden = !selected;
      section.querySelectorAll('.news-page__list, .pagination').forEach((element) => {
        element.hidden = Boolean(selected);
      });
      links.forEach((link) => {
        const active = selected ? link === selected : new URL(link.href).pathname === window.location.pathname && !new URL(link.href).hash;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    });
  }
  window.addEventListener('hashchange', () => update());
  document.addEventListener('shopify:section:load', (event) => update(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update());
  else update();
})();
